import React from "react";
import PropTypes from 'prop-types';

const notifyResize = (height) => {
    if (window.innerHeight === height) {
        // already at the right size
        return;
    }

    //notify parent of size change
    window.parent.postMessage({
        // piglet expects payload, but grootframe works with the height directly in the message
        height,
        payload: {
            height,
        },
        // Legacy required for grootframe.js but useless with piglet
        id: window.name,
        type: "target-change-height",
    }, '*');
};


const { body } = document;

// compute the minimal height of the body of the frame
const getBodyHeight = () => Math.min(body.scrollHeight, body.offsetHeight);

// The context will allow the transit of the force callback
// which sets the minimum height
const Context = React.createContext({
    force: () => {},
});

export function useSetMinHeight() {
    return React.useContext(Context).force;
}


export function FollowResize({ children }) {
    // The forced min height
    const [minHeight, setMinHeight] = React.useState(null);

    // The last height notified to the parent frame
    React.useEffect(() => {
        // when the minHeight is null, we are not in automatic mode
        if (minHeight !== null) {
            // height is the greater of the natural height and the
            // manually set minHeight
            notifyResize(Math.max(minHeight, getBodyHeight()));
            return;
        }

        // minHeight is null, we are in automatic mode
        // set a timer every few ms to compare the required height with the
        // previous height, if it changed we notify the parent
        let last = 0;
        const timerRef = setInterval(() => {
            const height = getBodyHeight();
            // height did not change
            if (height === last) {
                return;
            }
            last = height;
            notifyResize(height);
        }, 50);

        return () => clearInterval(timerRef);
    }, [minHeight]);

    return <Context.Provider value={ { force: setMinHeight } } >
        { children }
    </Context.Provider>;
}

FollowResize.propTypes = {
    children: PropTypes.node.isRequired,
};
